var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.initialized)?_c('div',[_c('WinbackWebview')],1):_c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"100vh"}},[_c('b-spinner',{attrs:{"variant":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }